(function($){

$(function() {

	var hauteur = $('.home-hightlight').height();
	var lastScrollTop = 0;

	$( window ).on( "scroll", function(){
		var posscrool = $( this ).scrollTop();

		//scroll vers le bas
		if( posscrool > lastScrollTop ){
		    if(posscrool>=(hauteur-100)) {
				$('body#idForTransparentMenu').removeAttr('id');
			}
		}
		//scroll vers le haut
		else{
			if(posscrool<=(hauteur-100)) {
				$('body').attr('id', 'idForTransparentMenu');
			}
		}
		lastScrollTop = posscrool;
	});

});

})(jQuery);
